import { mergeProps, useRender } from '@base-ui/react';

import { containerStyle } from './Container.css';

type Props = useRender.ComponentProps<'main'>;

export const Container = ({ render, ...delegated }: Props) => {
  return useRender({
    defaultTagName: 'main',
    render,
    props: mergeProps<'main'>(
      {
        className: containerStyle,
      },
      delegated,
    ),
  });
};
